var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "debt" } },
    [
      _c("DebtorTags", {
        attrs: { "has-codebtor": _vm.simulation.prospect.hasCodebtor },
      }),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.showAddDebtForm
              ? _c(
                  "div",
                  { attrs: { id: "add-debt" } },
                  [
                    _c(
                      "ValidationObserver",
                      { ref: "observer" },
                      [
                        _c(
                          "b-field",
                          {
                            staticClass: "field-separation",
                            attrs: {
                              label: "Identificador de la deuda",
                              horizontal: "",
                            },
                          },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("b-input", {
                                          attrs: {
                                            size: "is-small",
                                            placeholder:
                                              "Ingrese una descripción",
                                            expanded: "",
                                          },
                                          model: {
                                            value: _vm.formDebt.description,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formDebt,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression: "formDebt.description",
                                          },
                                        }),
                                        _c(
                                          "p",
                                          { staticClass: "help is-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                991956945
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          {
                            staticClass: "field-separation",
                            attrs: {
                              label: "Indique el plazo de la deuda",
                              horizontal: "",
                            },
                          },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "b-select",
                                          {
                                            attrs: {
                                              size: "is-small",
                                              placeholder:
                                                "Selecciona el plazo",
                                              "data-cy": "debt-term",
                                              expanded: "",
                                            },
                                            model: {
                                              value: _vm.formDebt.term,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formDebt,
                                                  "term",
                                                  $$v
                                                )
                                              },
                                              expression: "formDebt.term",
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "LONG_TERM" } },
                                              [_vm._v("Largo plazo")]
                                            ),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "SHORT_TERM" },
                                              },
                                              [_vm._v("Corto plazo")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          { staticClass: "help is-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4242516751
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          {
                            staticClass: "field-separation",
                            attrs: {
                              label: "Indique monto total de la deuda",
                              horizontal: "",
                            },
                          },
                          [
                            _c("BaseInput", {
                              attrs: {
                                rules:
                                  (!_vm.formDebt.knowsOutstandingBalance &&
                                    !_vm.formDebt.knowsMonthlyPayment) ||
                                  _vm.formDebt.knowsOutstandingBalance
                                    ? "required"
                                    : "",
                                field: {
                                  placeholder: "0.00",
                                  type: "number",
                                  prefix: "$",
                                  prefixPosition: "left",
                                },
                              },
                              model: {
                                value: _vm.formDebt.totalDebtAmount,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formDebt, "totalDebtAmount", $$v)
                                },
                                expression: "formDebt.totalDebtAmount",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "field-separation" },
                          [
                            _c(
                              "b-field",
                              [
                                _c("b-switch", {
                                  staticClass: "mr-2",
                                  attrs: { size: "is-small" },
                                  model: {
                                    value: _vm.formDebt.knowsOutstandingBalance,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formDebt,
                                        "knowsOutstandingBalance",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formDebt.knowsOutstandingBalance",
                                  },
                                }),
                                _c("span", { staticClass: "is-inline-block" }, [
                                  _vm._v(" ¿Conoce el saldo insoluto? "),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "b-collapse",
                              {
                                attrs: {
                                  open: _vm.formDebt.knowsOutstandingBalance,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "columns" },
                                  [
                                    _c("BaseInput", {
                                      staticClass: "column mt-3",
                                      attrs: {
                                        rules: _vm.formDebt
                                          .knowsOutstandingBalance
                                          ? "required"
                                          : "",
                                        field: {
                                          placeholder: "0.00",
                                          type: "number",
                                          prefix: "$",
                                          prefixPosition: "left",
                                        },
                                      },
                                      model: {
                                        value: _vm.formDebt.outstandingBalance,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formDebt,
                                            "outstandingBalance",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formDebt.outstandingBalance",
                                      },
                                    }),
                                    _c("div", { staticClass: "column" }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "field-separation" },
                          [
                            _c(
                              "b-field",
                              [
                                _c("b-switch", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    size: "is-small",
                                    "data-cy": "knowsMonthlyPayment",
                                  },
                                  model: {
                                    value: _vm.formDebt.knowsMonthlyPayment,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formDebt,
                                        "knowsMonthlyPayment",
                                        $$v
                                      )
                                    },
                                    expression: "formDebt.knowsMonthlyPayment",
                                  },
                                }),
                                _c("span", { staticClass: "is-inline-block" }, [
                                  _vm._v(
                                    " ¿Conoce la cuota que paga mensualmente? "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "b-collapse",
                              {
                                attrs: {
                                  open: _vm.formDebt.knowsMonthlyPayment,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "columns" },
                                  [
                                    _c("BaseInput", {
                                      staticClass: "column mt-3",
                                      attrs: {
                                        field: {
                                          placeholder: "0,00",
                                          type: "number",
                                          prefix: "$",
                                          prefixPosition: "left",
                                        },
                                        rules: _vm.formDebt.knowsMonthlyPayment
                                          ? "required"
                                          : "",
                                      },
                                      model: {
                                        value: _vm.formDebt.monthlyPayment,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formDebt,
                                            "monthlyPayment",
                                            $$v
                                          )
                                        },
                                        expression: "formDebt.monthlyPayment",
                                      },
                                    }),
                                    _c("div", { staticClass: "column" }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.formDebt.term === "LONG_TERM"
                          ? _c(
                              "b-field",
                              {
                                staticClass: "field-separation",
                                attrs: { label: "Inversión", horizontal: "" },
                              },
                              [
                                _c("BaseInput", {
                                  attrs: { field: { type: "switch" } },
                                  model: {
                                    value: _vm.formDebt.isInvestor,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formDebt, "isInvestor", $$v)
                                    },
                                    expression: "formDebt.isInvestor",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.formDebt.term === "SHORT_TERM"
                          ? _c(
                              "b-field",
                              {
                                staticClass: "field-separation",
                                attrs: { label: "Liquidación", horizontal: "" },
                              },
                              [
                                _c("BaseInput", {
                                  attrs: { field: { type: "switch" } },
                                  model: {
                                    value: _vm.formDebt.isLiquidation,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formDebt,
                                        "isLiquidation",
                                        $$v
                                      )
                                    },
                                    expression: "formDebt.isLiquidation",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c("div", { attrs: { id: "debt-resume" } }, [
                  _c("h4", [_vm._v("Deudas ingresadas")]),
                  _vm.inputDebt.length > 0
                    ? _c(
                        "table",
                        { staticClass: "table is-striped is-fullwidth" },
                        [
                          _vm._m(0),
                          _c(
                            "tbody",
                            _vm._l(_vm.inputDebt, function (item, i) {
                              return _c("tr", { key: i }, [
                                _c("td", [_vm._v(_vm._s(item.description))]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.monthlyDebtCalculate(item))
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.termLabels[item.term])),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          type: "is-light",
                                          rounded: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeDebt(i)
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "trash" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            0
                          ),
                        ]
                      )
                    : _c("p", { staticClass: "text-center field-separation" }, [
                        _vm._v("Sin deuda ingresada"),
                      ]),
                ]),
            _vm.showAddDebtForm
              ? _c(
                  "b-button",
                  {
                    attrs: {
                      type: "is-primary is-light is-pulled-right mt-3",
                      size: "is-small",
                      "data-cy": "btn-update-debt",
                    },
                    on: { click: _vm.update },
                  },
                  [_vm._v(" Guardar deuda ")]
                )
              : _vm._e(),
            _vm.showAddDebtForm
              ? _c(
                  "b-button",
                  {
                    attrs: {
                      type: "is-secondary is-light is-pulled-right mt-3 mr-3",
                      size: "is-small",
                      "data-cy": "btn-cancel-debt",
                    },
                    on: { click: _vm.toggleDebt },
                  },
                  [_vm._v(" Cancelar ")]
                )
              : _c(
                  "b-button",
                  {
                    attrs: {
                      type: "is-primary is-light is-pulled-right mt-3",
                      size: "is-small",
                      "data-cy": "btn-show-debt",
                    },
                    on: { click: _vm.showForm },
                  },
                  [
                    _c("span", { staticClass: "mr-2" }, [_vm._v("+")]),
                    _vm._v(" Agregar deuda "),
                  ]
                ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column pl-6" },
          [
            _c("TableSummary", {
              attrs: {
                title: "Deuda total mensual",
                "icon-label": _vm.totalDebtCardSummary,
                "show-icon-label": "",
                "data-cy": "total-debt-card",
                data: _vm.debtCardSummary,
              },
            }),
            _c("DocumentsVerification", {
              attrs: {
                label: _vm.label,
                type: "debt",
                "evaluation-id": _vm.evaluationId,
                "one-client-id": _vm.oneClientId,
                "validate-documents": _vm.validateDocuments,
              },
              on: { "documents-uploaded": _vm.handleDocumentsUploaded },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Descripción")]),
        _c("th", [_vm._v("Cuota Mensual")]),
        _c("th", [_vm._v("Plazo")]),
        _c("th", [_vm._v("Acciones")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }